if (!customElements.get('voicsky-image-selector')) {
  customElements.define('voicsky-image-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.panels = [...this.querySelectorAll('[data-image-panel]')];
      const list = this.querySelector('.vis__tabs');
      if (!list.children.length) {
        this.panels.forEach((panel, index) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.id = `ImageTab-${panel.dataset.imagePanel}`;
          tab.dataset.imageTab = panel.dataset.imagePanel;
          tab.textContent = panel.dataset.imageLabel;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          tab.setAttribute('aria-selected', String(index === 0));
          tab.tabIndex = index === 0 ? 0 : -1;
          panel.setAttribute('aria-labelledby', tab.id);
          panel.hidden = index !== 0;
          list.append(tab);
        });
      }
      this.tabs = [...this.querySelectorAll('[data-image-tab]')];
      this.setAttribute('data-ready', '');
      this.stage = this.querySelector('.vis__stage');
      this.index = 0;
      this.request = 0;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.tabs[next].focus({ preventScroll: true });
          this.select(next);
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-image-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.select(index);
      }, { signal });
    }
    async select(index) {
      if (!this.tabs[index]) return;
      const request = ++this.request;
      const panel = this.panels[index];
      const image = panel.querySelector('img');
      this.stage.setAttribute('aria-busy', 'true');
      if (image) {
        image.loading = 'eager';
        try { await image.decode(); } catch { }
      }
      if (!this.isConnected || request !== this.request) return;
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const list = this.tabs[index].parentElement;
      const tab = this.tabs[index];
      const offset = tab.getBoundingClientRect().left - list.getBoundingClientRect().left;
      if (matchMedia('(max-width: 749px)').matches || offset < 0 || offset + tab.offsetWidth > list.clientWidth) list.scrollBy({ left: offset - (list.clientWidth - tab.offsetWidth) / 2, behavior: reduced ? 'instant' : 'smooth' });
      // Keep only the current image visible until the replacement has decoded.
      // Fade the stage in sequence so transparent images never overlap.
      if (index !== this.index && !reduced) {
        await this.fadeStage(0, 160);
        if (!this.isConnected || request !== this.request) return;
      }
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.index = index;
      if (reduced) {
        this.transition?.cancel();
        this.stage.style.opacity = '1';
      } else {
        await this.fadeStage(1, 240);
      }
      if (this.isConnected && request === this.request) this.stage.setAttribute('aria-busy', 'false');
    }
    async fadeStage(opacity, duration) {
      const from = getComputedStyle(this.stage).opacity;
      this.stage.style.opacity = from;
      this.transition?.cancel();
      const animation = this.stage.animate([{ opacity: from }, { opacity }], {
        duration, easing: 'ease-in-out', fill: 'forwards'
      });
      this.transition = animation;
      try {
        await animation.finished;
        if (this.transition === animation) {
          this.stage.style.opacity = String(opacity);
          animation.cancel();
          this.transition = null;
        }
      } catch { }
    }
    disconnectedCallback() {
      this.request++;
      this.controller?.abort();
      this.controller = null;
      this.transition?.cancel();
      if (this.stage) this.stage.style.opacity = '1';
      this.panels?.forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
    }
  });
}
